function directSpoilerCards(container) {
  return Array.from(container.children).filter((child) => child.classList.contains("spoiler-card"))
}

function firstRenderedRowCards(cards) {
  const firstCard = cards[0]
  if (!firstCard) return []

  const firstRect = firstCard.getBoundingClientRect()

  if (firstRect.width === 0 && firstRect.height === 0) return []

  const firstTop = firstRect.top
  return cards.filter((card) => Math.abs(card.getBoundingClientRect().top - firstTop) <= 4)
}

export function positionSealedProductsFrameAfterFirstRow(container, frame) {
  if (!container || !frame) return false

  const originalDisplay = frame.style.display
  frame.style.display = "none"

  const rowCards = firstRenderedRowCards(directSpoilerCards(container))
  frame.style.display = originalDisplay

  if (rowCards.length === 0) return false

  rowCards[rowCards.length - 1].insertAdjacentElement("afterend", frame)
  return true
}
